import { useState, useEffect, useRef } from "react";
import { S, NAVY, GOLD, WHITE, BORDER, BEIGE, GREEN_BG, GREEN, SLATE } from "../constants";

export function Pagination({ cur, total, onChange }) {
  return total <= 1 ? null : (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 16, padding: 16, borderTop: "1px solid " + BORDER }}>
      <button onClick={() => onChange(Math.max(1, cur - 1))} disabled={cur === 1} style={{ ...S.btnGhost, padding: "6px 14px", opacity: cur === 1 ? 0.4 : 1 }}>{"<"}</button>
      <span style={{ fontSize: 13, color: "#5B6770" }}>Page <strong>{cur}</strong> of {total}</span>
      <button onClick={() => onChange(Math.min(total, cur + 1))} disabled={cur === total} style={{ ...S.btnGhost, padding: "6px 14px", opacity: cur === total ? 0.4 : 1 }}>{">"}</button>
    </div>
  );
}

export function FilterDropdown({ show, onToggle, value, options, onChange, label }) {
  return (
    <div style={{ position: "relative" }}>
      <button onClick={onToggle} style={{ ...S.btnGhost, display: "flex", alignItems: "center", gap: 6 }}>☰ {value !== "All" ? value : label}{value !== "All" && <span style={{ width: 7, height: 7, borderRadius: "50%", background: GOLD, display: "inline-block" }} />}</button>
      {show && <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, background: WHITE, border: "1px solid " + BORDER, borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.12)", zIndex: 50, minWidth: 180, overflow: "hidden" }}>{["All", ...options].map(s => (<div key={s} onClick={() => onChange(s)} style={{ padding: "10px 16px", fontSize: 13, cursor: "pointer", color: value === s ? GOLD : NAVY, fontWeight: value === s ? 700 : 400, background: value === s ? "#FFFAF3" : WHITE }}>{s}</div>))}</div>}
    </div>
  );
}

export function ActivityFeed({ items, onAdd }) {
  const safeItems = Array.isArray(items) ? items : [];
  const [expandedDraft, setExpandedDraft] = useState(null);
  const [editedDrafts, setEditedDrafts] = useState({});
  const [copiedIdx, setCopiedIdx] = useState(null);
  const copyToClipboard = (text, idx) => {
    navigator.clipboard.writeText(text).then(() => { setCopiedIdx(idx); setTimeout(() => setCopiedIdx(null), 2000); });
  };
  return (
    <div style={{ ...S.card, padding: "24px 28px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div style={{ fontFamily: "Merriweather,serif", fontWeight: 700, color: NAVY, fontSize: 15 }}>Activity ({safeItems.length})</div>
        <button onClick={onAdd} style={{ width: 32, height: 32, borderRadius: "50%", background: NAVY, color: WHITE, border: "none", fontSize: 20, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
      </div>
      {safeItems.length === 0
        ? <div style={{ color: "#5B6770", fontSize: 13, textAlign: "center", padding: 20 }}>No activity logged yet.</div>
        : safeItems.map((a, i) => {
            const hasDraft = a.fromGmail && a.draft;
            const isExpanded = expandedDraft === i;
            const draftBody = editedDrafts[i] !== undefined ? editedDrafts[i] : (a.draft?.body || "");
            return (
              <div key={i} style={{ marginBottom: 16 }}>
                <div style={{ paddingBottom: hasDraft ? 10 : 16, borderBottom: (!hasDraft && i < safeItems.length - 1) ? "1px solid " + BORDER : "none", ...(a.fromGmail ? { background: "#FFFCF5", margin: "0 -8px 0", padding: "10px 8px 8px", borderRadius: hasDraft ? "8px 8px 0 0" : 8, borderLeft: "3px solid " + GOLD } : {}) }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6, alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <span style={{ fontWeight: 700, fontSize: 13 }}>{a.type != null ? a.type : "Activity"}</span>
                      {a.fromGmail && <span style={{ fontSize: 10, background: "#FEF9EE", color: GOLD, border: "1px solid " + GOLD, padding: "1px 6px", borderRadius: 4, fontWeight: 600 }}>Gmail</span>}
                      {hasDraft && <span style={{ fontSize: 10, background: GREEN_BG, color: GREEN, border: "1px solid #86EFAC", padding: "1px 6px", borderRadius: 4, fontWeight: 600 }}>✦ Draft Ready</span>}
                    </div>
                    <span style={{ fontSize: 11, color: "#5B6770" }}>{a.date != null ? String(a.date) : "—"}</span>
                  </div>
                  <div style={{ fontSize: 13, color: "#5B6770", lineHeight: 1.6, whiteSpace: "pre-line" }}>{a.content != null ? a.content : "—"}</div>
                </div>
                {hasDraft && (
                  <div style={{ background: "#FAFFF9", border: "1px solid #86EFAC", borderTop: "none", borderRadius: "0 0 8px 8px", margin: "0 -8px", overflow: "hidden" }}>
                    <button onClick={() => setExpandedDraft(isExpanded ? null : i)} style={{ width: "100%", padding: "10px 14px", background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", fontFamily: "Open Sans, sans-serif" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 14 }}>✦</span>
                        <span style={{ fontSize: 12, fontWeight: 700, color: GREEN }}>AI Draft Response</span>
                        <span style={{ fontSize: 11, color: "#5B6770" }}>— ready to send</span>
                      </div>
                      <span style={{ fontSize: 12, color: "#5B6770", transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)", display: "inline-block", transition: "transform 0.2s" }}>▼</span>
                    </button>
                    {isExpanded && (
                      <div style={{ padding: "0 14px 14px" }}>
                        <div style={{ marginBottom: 10 }}>
                          <div style={{ fontSize: 11, color: "#5B6770", fontWeight: 600, marginBottom: 4 }}>SUBJECT</div>
                          <div style={{ fontSize: 12, color: NAVY, background: WHITE, border: "1px solid " + BORDER, borderRadius: 6, padding: "7px 10px", fontWeight: 600 }}>{a.draft.subject}</div>
                        </div>
                        <div style={{ marginBottom: 12 }}>
                          <div style={{ fontSize: 11, color: "#5B6770", fontWeight: 600, marginBottom: 4 }}>DRAFT BODY <span style={{ fontWeight: 400, color: "#5B6770" }}>(click to edit)</span></div>
                          <textarea value={draftBody} onChange={e => setEditedDrafts({ ...editedDrafts, [i]: e.target.value })} rows={10} style={{ width: "100%", padding: "10px 12px", border: "1px solid " + BORDER, borderRadius: 8, fontSize: 12, color: NAVY, background: WHITE, outline: "none", boxSizing: "border-box", fontFamily: "Open Sans, sans-serif", lineHeight: 1.7, resize: "vertical" }} />
                        </div>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                          <a href={`mailto:?subject=${encodeURIComponent(a.draft.subject)}&body=${encodeURIComponent(draftBody)}`} style={{ ...S.btnPrimary, fontSize: 12, padding: "7px 14px", textDecoration: "none" }}>✉ Open in Mail</a>
                          <button onClick={() => copyToClipboard(`Subject: ${a.draft.subject}\n\n${draftBody}`, i)} style={{ ...S.btnGold, fontSize: 12, padding: "7px 14px" }}>{copiedIdx === i ? "✓ Copied!" : "Copy Draft"}</button>
                          {editedDrafts[i] !== undefined && <button onClick={() => { const u = { ...editedDrafts }; delete u[i]; setEditedDrafts(u); }} style={{ ...S.btnGhost, fontSize: 12, padding: "7px 14px" }}>Reset</button>}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {i < safeItems.length - 1 && <div style={{ borderTop: "1px solid " + BORDER, marginTop: 16 }} />}
              </div>
            );
          })
      }
    </div>
  );
}

export function CustomFieldInput({ field, value, onChange }) {
  if (field.type === "Dropdown") return <select value={value || ""} onChange={e => onChange(e.target.value)} style={S.input}><option value="">Select...</option>{field.options.map(o => <option key={o} value={o}>{o}</option>)}</select>;
  if (field.type === "Checkbox") return <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}><input type="checkbox" checked={!!value} onChange={e => onChange(e.target.checked)} /><span style={{ fontSize: 13, color: NAVY }}>{field.label}</span></label>;
  if (field.type === "Textarea") return <textarea value={value || ""} onChange={e => onChange(e.target.value)} rows={3} style={{ ...S.input, resize: "vertical" }} />;
  if (field.type === "Date") return <input type="date" value={value || ""} onChange={e => onChange(e.target.value)} style={S.input} />;
  if (field.type === "Number") return <input type="number" value={value || ""} onChange={e => onChange(e.target.value)} style={S.input} />;
  return <input type="text" value={value || ""} onChange={e => onChange(e.target.value)} style={S.input} placeholder={field.label} />;
}

export function ListEditor({ title, items, onSave, onClose, showToast }) {
  const [localItems, setLocalItems] = useState([...items]);
  const [newItem, setNewItem] = useState("");
  return (
    <div style={S.modal}><div style={{ ...S.modalBox, width: 440 }}>
      <h3 style={{ margin: "0 0 4px", fontFamily: "Merriweather,serif", fontSize: 18, color: NAVY }}>Edit {title}</h3>
      <p style={{ margin: "0 0 20px", fontSize: 13, color: "#5B6770" }}>Add or remove items from this list.</p>
      <div style={{ marginBottom: 16 }}>{localItems.map((item, i) => (<div key={i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", background: i % 2 === 0 ? WHITE : BEIGE, borderRadius: 6, marginBottom: 4 }}><span style={{ color: "#5B6770", fontSize: 13, flex: 1 }}>{item}</span><button onClick={() => setLocalItems(localItems.filter((_, j) => j !== i))} style={{ background: "none", border: "none", color: "#EF4444", cursor: "pointer", fontSize: 16 }}>×</button></div>))}</div>
      <div style={{ display: "flex", gap: 8, marginBottom: 20 }}><input value={newItem} onChange={e => setNewItem(e.target.value)} onKeyDown={e => { if (e.key === "Enter" && newItem.trim()) { setLocalItems([...localItems, newItem.trim()]); setNewItem(""); }}} placeholder="Add new item..." style={{ ...S.input, flex: 1 }} /><button onClick={() => { if (newItem.trim()) { setLocalItems([...localItems, newItem.trim()]); setNewItem(""); }}} style={S.btnPrimary}>Add</button></div>
      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}><button onClick={onClose} style={S.btnGhost}>Cancel</button><button onClick={() => { onSave(localItems); onClose(); if (showToast) showToast(title + " saved"); }} style={S.btnPrimary}>Save Changes</button></div>
    </div></div>
  );
}

export function MultiSelect({ label, options, value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  const toggle = (opt) => {
    onChange(value.includes(opt) ? value.filter(v => v !== opt) : [...value, opt]);
  };
  const displayLabel = value.length === 0 ? label : value.length === 1 ? (options.find(o => o.value === value[0])?.label ?? value[0]) : `${value.length} selected`;
  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{ display: "flex", alignItems: "center", gap: 6, padding: "7px 12px", border: "1px solid #d1d5db", borderRadius: 6, background: "#fff", fontSize: 12, cursor: "pointer", minWidth: 130, justifyContent: "space-between", fontFamily: "Open Sans,sans-serif", color: value.length > 0 ? "#0369A1" : "#374151" }}
      >
        <span>{displayLabel}</span>
        <span style={{ fontSize: 10, color: "#9ca3af" }}>▼</span>
      </button>
      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 999, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 4px 16px rgba(0,0,0,0.1)", minWidth: 180, padding: "6px 0" }}>
          {options.map(opt => (
            <label key={opt.value} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 14px", cursor: "pointer", fontSize: 12, color: "#374151", fontFamily: "Open Sans,sans-serif" }}
              onMouseEnter={e => { e.currentTarget.style.background = "#f9fafb"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
            >
              <input type="checkbox" checked={value.includes(opt.value)} onChange={() => toggle(opt.value)} style={{ accentColor: "#0369A1" }} />
              {opt.label}
            </label>
          ))}
          {value.length > 0 && (
            <div style={{ borderTop: "1px solid #f3f4f6", marginTop: 4, paddingTop: 4 }}>
              <button onClick={() => { onChange([]); setOpen(false); }} style={{ width: "100%", textAlign: "center", fontSize: 11, color: "#ef4444", background: "none", border: "none", cursor: "pointer", padding: "6px 0", fontFamily: "Open Sans,sans-serif" }}>
                Clear
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export function AttachmentsPanel({ attachments = [], onAdd, onDelete, readOnly }) {
  const [showForm, setShowForm] = useState(false);
  const [type, setType] = useState("link");
  const [label, setLabel] = useState("");
  const [url, setUrl] = useState("");
  const [fileData, setFileData] = useState(null);

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      setFileData({ name: file.name, size: file.size, mime: file.type, data: ev.target.result });
      setLabel(file.name);
    };
    reader.readAsDataURL(file);
  };

  const handleAdd = () => {
    if (!label) return;
    if (type === "link" && !url) return;
    if (type === "file" && !fileData) return;
    const attachment = {
      id: Date.now(),
      type,
      label,
      url: type === "link" ? url : null,
      fileData: type === "file" ? fileData : null,
      addedAt: new Date().toISOString()
    };
    onAdd(attachment);
    setShowForm(false);
    setLabel(""); setUrl(""); setFileData(null); setType("link");
  };

  return (
    <div style={{ marginTop: 24 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: SLATE, textTransform: "uppercase" }}>Attachments & Links</div>
        {!readOnly && <button onClick={() => setShowForm(!showForm)} style={{ background: NAVY, color: "#fff", border: "none", borderRadius: 6, padding: "4px 12px", fontSize: 12, cursor: "pointer" }}>+ Add</button>}
      </div>

      {showForm && (
        <div style={{ background: "#f9f9f9", borderRadius: 8, padding: 16, marginBottom: 12 }}>
          <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
            {["link", "file"].map(t => (
              <button key={t} onClick={() => setType(t)} style={{ padding: "4px 16px", borderRadius: 6, border: `1px solid ${type === t ? NAVY : "#ccc"}`, background: type === t ? NAVY : "#fff", color: type === t ? "#fff" : "#333", cursor: "pointer", fontSize: 13 }}>
                {t === "link" ? "🔗 Link" : "📄 File"}
              </button>
            ))}
          </div>
          <input style={{ ...S.input, marginBottom: 8 }} placeholder="Label" value={label} onChange={e => setLabel(e.target.value)} />
          {type === "link" && <input style={{ ...S.input, marginBottom: 8 }} placeholder="https://..." value={url} onChange={e => setUrl(e.target.value)} />}
          {type === "file" && <input type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg" onChange={handleFile} style={{ marginBottom: 8 }} />}
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={handleAdd} style={{ background: GOLD, color: "#fff", border: "none", borderRadius: 6, padding: "6px 16px", cursor: "pointer", fontSize: 13 }}>Save</button>
            <button onClick={() => setShowForm(false)} style={{ background: "#eee", border: "none", borderRadius: 6, padding: "6px 16px", cursor: "pointer", fontSize: 13 }}>Cancel</button>
          </div>
        </div>
      )}

      {attachments.length === 0 && <div style={{ color: "#999", fontSize: 13 }}>No attachments yet.</div>}
      {attachments.map(a => (
        <div key={a.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #eee" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span>{a.type === "link" ? "🔗" : "📄"}</span>
            {a.type === "link"
              ? <a href={a.url} target="_blank" rel="noreferrer" style={{ color: NAVY, fontSize: 13 }}>{a.label}</a>
              : <a href={a.fileData?.data} download={a.label} style={{ color: NAVY, fontSize: 13 }}>{a.label}</a>
            }
          </div>
          {!readOnly && <button onClick={() => onDelete(a.id)} style={{ background: "none", border: "none", color: "#e74c3c", cursor: "pointer", fontSize: 16 }}>×</button>}
        </div>
      ))}
    </div>
  );
}
